<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}</label>
    <input
      :id="id"
      ref="fileInput"
      type="file"
      class="hidden"
      :accept="accept"
      @change="change"
    />
    <div class="mt-1 flex items-center">
      <button
        type="button"
        class="form-input flex flex-1 items-center"
        @click="$refs.fileInput.click()"
      >
        <span class="flex-1 min-h-[24px] flex items-center">
          <template v-if="modelValue">
            <template v-if="isFile(modelValue)">
              {{ modelValue.name }}
              <span class="text-gray-500"
                >({{ formatFileSize(modelValue.size) }})</span
              >
            </template>
            <template v-else-if="isPhotoObject(modelValue)">
              {{ getFileName(modelValue.full) }}
            </template>
            <template v-else>
              {{ getFileName(modelValue) }}
            </template>
          </template>
          <span v-else class="text-gray-500">Browse</span>
        </span>
      </button>
      <button
        v-if="modelValue"
        type="button"
        class="ml-3 text-sm text-gray-500 hover:text-gray-700"
        @click="remove"
      >
        Удалить
      </button>
    </div>
    <div v-if="errors?.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: [File, String, Object],
      default: null,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 9),
    },
    accept: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  methods: {
    change(event) {
      this.$emit('update:modelValue', event.target.files[0]);
    },
    remove() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
      // For photo objects, we need to send a special value to indicate deletion
      if (this.isPhotoObject(this.modelValue)) {
        this.$emit('update:modelValue', { _destroy: true });
      } else {
        this.$emit('update:modelValue', null);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    isFile(value) {
      return value instanceof File;
    },
    isPhotoObject(value) {
      return (
        value &&
        typeof value === 'object' &&
        'thumbnail' in value &&
        'full' in value
      );
    },
    getFileName() {
      if (!this.modelValue) return '';
      if (this.isPhotoObject(this.modelValue)) {
        return this.modelValue.thumbnail.split('/').pop();
      }
      if (this.modelValue instanceof File) {
        return this.modelValue.name;
      }
      if (typeof this.modelValue === 'string') {
        return this.modelValue.split('/').pop();
      }
      return '';
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        if (!val && this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
      },
    },
  },
};
</script>
